import React from "react";

import { Notification as NotificationToaster, toaster } from "rsuite";
import styled from "styled-components";

// import { ITeamInvitation } from "features/teams/types/team.interface";
import { Like } from "features/likes";
import { Notification } from "../features/notifications/types/index";
import {
  NotificationCard,
  NotificationCardToaster,
  RedDot,
} from "../features/notifications/components/NotificationCards/styled/index";

import FromNowDate from "../components/Elements/Date/FromNowDate";
import ProfileImage from "../components/Elements/ProfileImage/ProfileImage";
import { ProjectComment } from "../features/post-comments/index";
import { useAppSelector } from "../store/hooks";
import { getColorTheme } from "../store/slices/userSessionSlice";
import {
  dispatchAppendSocketNotification,
  dispatchSetNotificationAlert,
} from "../store/dispatcher";
import useAppNavigation from "./useAppNavigation";
import { IUserSession } from "../types/user.interface";

const Container = styled.div`
  margin-top: 12px;
`;
const openProjectCommentToaster = (
  notification: Notification,
  comment: ProjectComment,
  creator: IUserSession,
  duration: number,
  nav: () => void,
  theme: any
) => {
  toaster.push(
    <NotificationToaster
      data-theme={theme}
      id="notification-toaster"
      style={{ padding: 0 }}
      type="info"
      header="New Project Comment!"
      closable
    >
      <Container
        onClick={() => {
          nav();
          toaster.clear();
        }}
      >
        <NotificationCardToaster.Container
          style={{ borderBottomColor: "transparent" }}
        >
          <NotificationCard.ContainerLeft>
            {!notification.read && <RedDot />}
            <NotificationCard.ImageContainer>
              <ProfileImage
                url={notification.creator.profileImg}
                gender={notification.creator.gender}
              />
            </NotificationCard.ImageContainer>
          </NotificationCard.ContainerLeft>

          <NotificationCard.ContainerCenter>
            <NotificationCard.TitleContainer>
              <p>
                <strong>
                  <span>{creator.username}</span> commented on a project:
                </strong>
              </p>
            </NotificationCard.TitleContainer>
            <NotificationCard.BodyContainer>
              <NotificationCard.CommentBody>
                {comment.message}
              </NotificationCard.CommentBody>
            </NotificationCard.BodyContainer>
          </NotificationCard.ContainerCenter>

          <NotificationCard.ContainerRight>
            <NotificationCard.Timestamp>
              <FromNowDate date={notification.createdOn} />
            </NotificationCard.Timestamp>
          </NotificationCard.ContainerRight>
        </NotificationCardToaster.Container>
      </Container>
    </NotificationToaster>,
    { placement: "topEnd", duration }
  );
};

const openTeamProjectCommentToaster = (
  notification: Notification,
  comment: ProjectComment,
  creator: IUserSession,
  duration: number,
  nav: () => void,
  theme: any
) => {
  toaster.push(
    <NotificationToaster
      data-theme={theme}
      id="notification-toaster"
      style={{ padding: 0 }}
      type="info"
      header="New Project Comment!"
      closable
    >
      <Container
        onClick={() => {
          nav();
          toaster.clear();
        }}
      >
        <NotificationCardToaster.Container
          style={{ borderBottomColor: "transparent" }}
        >
          <NotificationCard.ContainerLeft>
            {!notification.read && <RedDot />}
            <NotificationCard.ImageContainer>
              <ProfileImage
                url={notification.creator.profileImg}
                gender={notification.creator.gender}
              />
            </NotificationCard.ImageContainer>
          </NotificationCard.ContainerLeft>

          <NotificationCard.ContainerCenter>
            <NotificationCard.TitleContainer>
              <p>
                <strong>
                  <span>{creator.username}</span> commented on a team project:
                </strong>
              </p>
            </NotificationCard.TitleContainer>
            <NotificationCard.BodyContainer>
              <NotificationCard.CommentBody>
                {comment.message}
              </NotificationCard.CommentBody>
            </NotificationCard.BodyContainer>
          </NotificationCard.ContainerCenter>

          <NotificationCard.ContainerRight>
            <NotificationCard.Timestamp>
              <FromNowDate date={notification.createdOn} />
            </NotificationCard.Timestamp>
          </NotificationCard.ContainerRight>
        </NotificationCardToaster.Container>
      </Container>
    </NotificationToaster>,
    { placement: "topEnd", duration }
  );
};

const openTeamInviteToaster = (
  notification: Notification,
  // invitation: ITeamInvitation,
  creator: IUserSession,
  duration: number,
  nav: () => void,
  // denyInvite: () => void,
  theme: any
) => {
  toaster.push(
    <NotificationToaster
      data-theme={theme}
      id="notification-toaster"
      style={{ padding: 0 }}
      type="info"
      header="New Team Invite!"
      closable
    >
      <Container
      // onClick={() => {
      //   nav();
      //   toaster.clear();
      // }}
      >
        <NotificationCardToaster.Container
          style={{ borderBottomColor: "transparent" }}
        >
          <NotificationCard.ContainerLeft>
            {!notification.read && <RedDot />}
            <NotificationCard.ImageContainer>
              <ProfileImage
                url={notification.creator.profileImg}
                gender={notification.creator.gender}
              />
            </NotificationCard.ImageContainer>
          </NotificationCard.ContainerLeft>

          <NotificationCard.ContainerCenter>
            <NotificationCard.TitleContainer>
              <p>
                <strong>
                  <span>{creator.username}</span> Invited you to the team:
                </strong>
              </p>
            </NotificationCard.TitleContainer>
            <NotificationCard.BodyContainer>
              {notification.teamInvitationNotification.team.teamName}

              {/* <p style={{ marginLeft: 10 }}>Deny:</p>
              <CloseOutlineIcon
                style={{ fontSize: 20, marginLeft: 5, marginTop: 5 }}
                onClick={denyInvite}
              />
              <p style={{ marginLeft: 15 }}>Accept:</p>
              <CheckOutlineIcon
                style={{ fontSize: 20, marginLeft: 10, marginTop: 5 }}
                onClick={acceptInvite}
              /> */}
            </NotificationCard.BodyContainer>
          </NotificationCard.ContainerCenter>

          <NotificationCard.ContainerRight>
            <NotificationCard.Timestamp>
              <FromNowDate date={notification.createdOn} />
            </NotificationCard.Timestamp>
          </NotificationCard.ContainerRight>
        </NotificationCardToaster.Container>
      </Container>
    </NotificationToaster>,
    { placement: "topEnd", duration }
  );
};

const openProjectLikeToaster = (
  notification: Notification,
  like: Like,
  creator: IUserSession,
  duration: number,
  nav: () => void,
  theme: any
) => {
  toaster.push(
    <NotificationToaster
      data-theme={theme}
      id="notification-toaster"
      style={{ padding: 0 }}
      type="info"
      header="New Project Like!"
      closable
    >
      <Container
        onClick={() => {
          nav();
          toaster.clear();
        }}
      >
        <NotificationCardToaster.Container
          style={{ borderBottomColor: "transparent" }}
        >
          <NotificationCard.ContainerLeft>
            {!notification.read && <RedDot />}
            <NotificationCard.ImageContainer>
              <ProfileImage
                url={notification.creator.profileImg}
                gender={notification.creator.gender}
              />
            </NotificationCard.ImageContainer>
          </NotificationCard.ContainerLeft>

          <NotificationCard.ContainerCenter>
            <NotificationCard.TitleContainer>
              <p>
                <strong>
                  <span>{creator.username}</span> Liked your project:
                </strong>
              </p>
            </NotificationCard.TitleContainer>
            <NotificationCard.BodyContainer>
              <NotificationCard.CommentBody style={{ textAlign: "center" }}>
                Click to view project
              </NotificationCard.CommentBody>
            </NotificationCard.BodyContainer>
          </NotificationCard.ContainerCenter>

          <NotificationCard.ContainerRight>
            <NotificationCard.Timestamp>
              <FromNowDate date={notification.createdOn} />
            </NotificationCard.Timestamp>
          </NotificationCard.ContainerRight>
        </NotificationCardToaster.Container>
      </Container>
    </NotificationToaster>,
    {
      placement: "topEnd",
      duration,
    }
  );
};

const AUTO_HIDE_TIMER = 4500;

export default function useNotificationToaster() {
  // get app navigation to generate links in the notifications
  const {
    navigateToProjectDetailsPage,
    navigateToTeamProjectDetailsPage,
    navigateToTeamPage,
  } = useAppNavigation();

  const theme = useAppSelector(getColorTheme);

  const displayCommentNotification = (data: string) => {
    const notification = JSON.parse(data) as Notification;
    const nav = () => {
      navigateToProjectDetailsPage(
        notification.projectCommentNotification.comment.post._id,
        notification.projectCommentNotification.comment._id
      );
    };

    openProjectCommentToaster(
      notification,
      notification.projectCommentNotification.comment,
      notification.creator,
      AUTO_HIDE_TIMER,
      nav,
      theme
    );

    dispatchSetNotificationAlert();
    dispatchAppendSocketNotification(notification);
  };

  const displayTeamCommentNotification = (data: string) => {
    const notification = JSON.parse(data) as Notification;

    const nav = () => {
      navigateToTeamProjectDetailsPage(
        notification.teamProjectCommentNotification.comment.post._id,
        notification.teamProjectCommentNotification.comment._id
      );
    };

    openTeamProjectCommentToaster(
      notification,
      notification.teamProjectCommentNotification.comment,
      notification.creator,
      AUTO_HIDE_TIMER,
      nav,
      theme
    );

    dispatchSetNotificationAlert();
    dispatchAppendSocketNotification(notification);
  };

  const displayTeamInviteNotification = (data: string) => {
    const notification = JSON.parse(data) as Notification;

    // const { accept, deny } = useTeamNotificationCard(notification);

    const nav = () => {
      navigateToTeamPage(notification.teamInvitationNotification.team._id);
    };

    // const acceptInvite = () => {
    //   accept()
    //     .then(() => {
    //       // The code inside this block will execute only when accept() is successful
    //       nav();
    //     })
    //     .catch((error) => {
    //       // The code inside this block will execute only when accept() fails
    //       console.log("Error accepting the invite: ", error);
    //     });
    // };

    // const denyInvite = () => {
    //   deny();
    // };

    openTeamInviteToaster(
      notification,
      notification.creator,
      AUTO_HIDE_TIMER,
      nav,
      theme
    );

    dispatchSetNotificationAlert();
    dispatchAppendSocketNotification(notification);
  };

  const displayProjectLikeNotification = (data: string) => {
    const notification = JSON.parse(data) as Notification;

    const nav = () => {
      navigateToProjectDetailsPage(
        notification.projectLikeNotification.like.postId._id
      );
    };

    openProjectLikeToaster(
      notification,
      notification.projectLikeNotification.like,
      notification.creator,
      AUTO_HIDE_TIMER,
      nav,
      theme
    );

    dispatchSetNotificationAlert();
    dispatchAppendSocketNotification(notification);
  };

  return {
    displayCommentNotification,
    displayTeamCommentNotification,
    displayTeamInviteNotification,
    displayProjectLikeNotification,
  };
}
